import styled from 'styled-components'
import { type ReactNode } from 'react'
import { Row } from '@shipt/design-system-layouts'
import { screenSizes } from '@shipt/design-system-themes'
import { CloseButton } from '@/features/shared/components/CloseButton'
import { getBoxShadow } from '@/features/shared/styles/effects'
import { C360Logo } from '@/features/shared/components/C360Logo'
import { theme } from '@/features/shared/constants/shiptTheme'

export const C360BannerWithCloseButtonContainer = ({
  children,
  onClick,
  justifyContent = 'start',
}: {
  children: ReactNode
  onClick: () => void
  justifyContent?: 'start' | 'center'
}) => {
  return (
    <Banner
      padding={{ base: ['sm', 'lg'], md: ['sm', 'lg'] }}
      align="center"
      justify={{ base: 'space-between', md: 'center' }}
      className="fullWidth"
    >
      <ContentRow
        spacing={{ base: 'md', md: 'xxl' }}
        align="center"
        justify={{ base: justifyContent, md: 'center' }}
      >
        <C360Logo />
        {children}
      </ContentRow>
      <CloseBannerButton onClick={onClick} />
    </Banner>
  )
}

const Banner = styled(Row)`
  background: ${theme.color.background.base.neutral.subtle_00};
  border-left: 4px solid ${theme.redCircle360};
  ${getBoxShadow('lift', 'light', false)};
  position: relative;
`

const ContentRow = styled(Row)`
  width: 100%;
`

const CloseBannerButton = styled(CloseButton)`
  color: inherit;

  @media ${screenSizes.max_mobile} {
    padding: 0.25rem;
  }
`
